import { render } from "./AnnotationBalcony.vue?vue&type=template&id=64eeff78"
import script from "./AnnotationBalcony.vue?vue&type=script&lang=js"
export * from "./AnnotationBalcony.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/Upwork/kaz/50sunset/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__